import styled from "styled-components";
import { width } from "styled-system";
import React, { useEffect } from "react";

const LazyImage = ({
  className = "",
  src,
  alt,
  width = 1,
  singleRender = true
}) => {
  let image = React.createRef();

  useEffect(() => {
    // Need to re-add the lazyload class when the
    // data updates so that the lazyload will rework
    if (!singleRender) {
      image.current.classList.add("lazyload");
    }
  });

  return (
    <S_Img
      ref={image}
      width={width}
      className={className + " lazyload"}
      data-src={src}
      alt={alt}
    />
  );
};

const S_Img = styled.img`
  ${width}
  opacity: 0;
  transition: 0.5s opacity;

  &.lazyloaded {
    opacity: 1;
  }
`;

export { LazyImage };
